<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_REPORT_SALE_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      is-list
      :before-reset-search="beforeResetSearch"
      :is-pagination="false"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleAnalysis.orderTime')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessReportSaleAnalysis.orderTime')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleAnalysis.channel')" prop="channel">
            <BjSelectLov v-model="queryParams.channel" :placeholder="$t('BusinessReportSaleCensus.channel')" lov-code="SCHL.CHANNEL_TYPE" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            :sortable="[labelListProps].includes(col.prop)"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template
                v-if="['orderAmount', 'reverseAmount', 'sendOrderAmount'].includes(col.prop)"
              >
                {{ $number2money(scope.row[col.prop]) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { reportApi } from '@/api';
import { BUSINESS_REPORT_SALE_ROUTE_LIST } from '@/utils/constants';
// 导入默认时间（两周前-今日），报表多页面通用
import { defaultDate, disabledDate } from '../commonData';

export default {
  name: 'BusinessReportSaleAnalysisIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: false,
      BUSINESS_REPORT_SALE_ROUTE_LIST,
      /** */
      queryApi: reportApi.getOrderDailyReport,
      // 查询参数
      queryParamsTime: defaultDate(),
      // 已核对字段
      queryParams: {
        channel: null,
        startDate: null,
        endDate: null,
      },
      pickerOptions: {
        // 限制时间选择一年内
        disabledDate(time) {
          return disabledDate(time);
        },
      },
      labelsVersion: 11,
      labelList: [
        {
          label: this.$t('BusinessReportSaleAnalysis.orderDate'),
          prop: 'orderDate',
          isCheck: true,
          disabled: false,
          width: 120
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.orderCount'),
          prop: 'orderCount',
          isCheck: true,
          disabled: false,
          width: 135
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.orderItemCount'),
          prop: 'orderItemCount',
          isCheck: true,
          disabled: false,
          width: 160
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.orderAmount'),
          prop: 'orderAmount',
          isCheck: true,
          disabled: false,
          width: 170
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.reverseCount'),
          prop: 'reverseCount',
          isCheck: true,
          disabled: false,
          width: 170
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.reverseItemCount'),
          prop: 'reverseItemCount',
          isCheck: true,
          disabled: false,
          width: 170
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.reverseAmount'),
          prop: 'reverseAmount',
          isCheck: true,
          disabled: false,
          width: 160
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.sendOrderCount'),
          prop: 'sendOrderCount',
          isCheck: true,
          disabled: false,
          width: 185
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.sendOrderItemCount'),
          prop: 'sendOrderItemCount',
          isCheck: true,
          disabled: false,
          width: 180
        },
        {
          label: this.$t('BusinessReportSaleAnalysis.sendOrderAmount'),
          prop: 'sendOrderAmount',
          isCheck: true,
          disabled: false,
          width: 225
        },
        // { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129},
      ],
      labelListProps: [],
    };
  },
  computed: {},
  watch: {
    queryParamsTime: {
      handler(v) {
        this.queryParams.startDate = (v || [])[0];
        this.queryParams.endDate = (v || [])[1];
      },
      immediate: true,
    },
  },
  created() {
    this.labelListProps = this.labelList.filter(e => e.prop !== 'orderDate').map(e => e.prop);
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = defaultDate();
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
